import { createContext, useContext } from "react";
import type { StoreItemType } from "../types";

interface StoreItemContextType {
    item: StoreItemType;
    state: string;
    setState: React.Dispatch<React.SetStateAction<string>>;
    /** Why the last purchase attempt was refused, shown on the failure screen. */
    error: string;
    setError: React.Dispatch<React.SetStateAction<string>>;
}

export const StoreItemContext = createContext<StoreItemContextType | undefined>(undefined)

export function useStoreItemContext() {
    const context = useContext(StoreItemContext)
    if (!context) {
        throw new Error('StoreItem compound components must be used within StoreItem')
    }
    return context
}